import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from './components/Header21';
import Footer from './components/Footer21';

const Template21Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = ['All', 'Lehengas', 'Sarees', 'Sherwanis', 'Anarkalis', 'Indo-Western'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        {
            id: 1,
            name: 'Midnight Silk Lehenga',
            category: 'Lehengas',
            price: 24999,
            image: 'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 2,
            name: 'Noir Banarasi Saree',
            category: 'Sarees',
            price: 18500,
            image: 'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 3,
            name: 'Black Zardozi Sherwani',
            category: 'Sherwanis',
            price: 32000,
            image: 'https://images.pexels.com/photos/6687182/pexels-photo-6687182.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 4,
            name: 'Emerald Velvet Anarkali',
            category: 'Anarkalis',
            price: 15999,
            image: 'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 5,
            name: 'Onyx Silk Dupatta Set',
            category: 'Indo-Western',
            price: 12499,
            image: 'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 6,
            name: 'Champagne Gold Saree',
            category: 'Sarees',
            price: 21000,
            image: 'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 7,
            name: 'Royal Crimson Lehenga',
            category: 'Lehengas',
            price: 28999,
            image: 'https://images.pexels.com/photos/9901808/pexels-photo-9901808.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 8,
            name: 'Ivory Chanderi Kurta',
            category: 'Indo-Western',
            price: 8999,
            image: 'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
    ];

    const filteredProducts = activeFilter === 'All'
        ? products
        : products.filter(p => p.category === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const totalPages = 3;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500;600;700&display=swap');

                .noir-shop-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .noir-shop-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 20px;
                    }
                }
                @media (min-width: 1024px) {
                    .noir-shop-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 24px;
                    }
                }
                .noir-filter-bar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    align-items: center;
                }
                @media (min-width: 768px) {
                    .noir-filter-bar {
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
                .noir-category-scroll {
                    display: flex;
                    gap: 10px;
                    overflow-x: auto;
                    padding-bottom: 4px;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .noir-category-scroll::-webkit-scrollbar {
                    display: none;
                }
                .noir-hero-section {
                    padding: 120px 24px 60px;
                }
                @media (min-width: 768px) {
                    .noir-hero-section {
                        padding: 140px 24px 80px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#0A0A0A' }}>
                <Header cartCount={0} />

                {/* Hero Banner */}
                <div
                    className="noir-hero-section"
                    style={{
                        backgroundColor: '#0A0A0A',
                        borderBottom: '1px solid #2A2A2A',
                        textAlign: 'center',
                    }}
                >
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <p
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#C9A96E',
                                letterSpacing: '4px',
                                textTransform: 'uppercase',
                                margin: '0 0 16px 0',
                            }}
                        >
                            Curated for you
                        </p>
                        <h1
                            style={{
                                fontFamily: "'Cormorant Garamond', Georgia, serif",
                                fontSize: 'clamp(36px, 6vw, 64px)',
                                fontWeight: 400,
                                color: '#C9A96E',
                                letterSpacing: '3px',
                                margin: '0 0 16px 0',
                                lineHeight: 1.1,
                            }}
                        >
                            Our Collection
                        </h1>
                        <p
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '16px',
                                fontWeight: 300,
                                color: '#F5F0EB',
                                margin: 0,
                                opacity: 0.85,
                                lineHeight: 1.6,
                            }}
                        >
                            Discover handcrafted luxury pieces that celebrate the art of Indian couture
                        </p>
                    </div>
                </div>

                {/* Main Content */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '40px 24px 80px' }}>

                    {/* Filter / Sort Bar */}
                    <div className="noir-filter-bar" style={{ marginBottom: '40px' }}>
                        {/* Category Pills */}
                        <div className="noir-category-scroll">
                            {categories.map(category => (
                                <button
                                    key={category}
                                    onClick={() => {
                                        setActiveFilter(category);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        padding: '10px 24px',
                                        backgroundColor: activeFilter === category ? '#C9A96E' : 'transparent',
                                        color: activeFilter === category ? '#0A0A0A' : '#F5F0EB',
                                        border: activeFilter === category ? '1px solid #C9A96E' : '1px solid #2A2A2A',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeFilter !== category) {
                                            e.currentTarget.style.borderColor = '#C9A96E';
                                            e.currentTarget.style.color = '#C9A96E';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeFilter !== category) {
                                            e.currentTarget.style.borderColor = '#2A2A2A';
                                            e.currentTarget.style.color = '#F5F0EB';
                                        }
                                    }}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>

                        {/* Sort Dropdown */}
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '13px',
                                fontWeight: 400,
                                color: '#F5F0EB',
                                backgroundColor: '#1A1A1A',
                                border: '1px solid #2A2A2A',
                                padding: '10px 40px 10px 16px',
                                outline: 'none',
                                cursor: 'pointer',
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23C9A96E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 12px center',
                                minWidth: '180px',
                            }}
                            onFocus={(e) => (e.currentTarget.style.borderColor = '#C9A96E')}
                            onBlur={(e) => (e.currentTarget.style.borderColor = '#2A2A2A')}
                        >
                            {sortOptions.map(option => (
                                <option key={option.value} value={option.value} style={{ backgroundColor: '#1A1A1A', color: '#F5F0EB' }}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Results count */}
                    <p
                        style={{
                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                            fontSize: '13px',
                            color: '#8A8A7A',
                            margin: '0 0 24px 0',
                        }}
                    >
                        Showing {sortedProducts.length} {sortedProducts.length === 1 ? 'piece' : 'pieces'}
                    </p>

                    {/* Product Grid */}
                    <div className="noir-shop-grid">
                        {sortedProducts.map(product => (
                            <div
                                key={product.id}
                                onClick={() => navigate(`/template21/product/${product.id}`)}
                                onMouseEnter={() => setHoveredCard(product.id)}
                                onMouseLeave={() => setHoveredCard(null)}
                                style={{
                                    backgroundColor: '#141414',
                                    border: `1px solid ${hoveredCard === product.id ? '#C9A96E' : '#2A2A2A'}`,
                                    cursor: 'pointer',
                                    transition: 'border-color 0.3s ease',
                                    overflow: 'hidden',
                                }}
                            >
                                {/* Image */}
                                <div
                                    style={{
                                        position: 'relative',
                                        aspectRatio: '3 / 4',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)',
                                            transition: 'transform 0.5s ease',
                                        }}
                                    />

                                    {/* Wishlist Heart */}
                                    <button
                                        onClick={(e) => toggleWishlist(e, product.id)}
                                        style={{
                                            position: 'absolute',
                                            top: '12px',
                                            right: '12px',
                                            width: '36px',
                                            height: '36px',
                                            backgroundColor: 'rgba(10, 10, 10, 0.6)',
                                            border: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s ease',
                                            backdropFilter: 'blur(4px)',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(10, 10, 10, 0.8)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(10, 10, 10, 0.6)')}
                                    >
                                        <Heart
                                            size={18}
                                            style={{
                                                color: wishlist[product.id] ? '#C9A96E' : '#F5F0EB',
                                                fill: wishlist[product.id] ? '#C9A96E' : 'none',
                                                transition: 'color 0.3s ease, fill 0.3s ease',
                                            }}
                                        />
                                    </button>
                                </div>

                                {/* Product Info */}
                                <div style={{ padding: '16px' }}>
                                    <h3
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            color: '#F5F0EB',
                                            margin: '0 0 8px 0',
                                            lineHeight: 1.4,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {product.name}
                                    </h3>
                                    <span
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#C9A96E',
                                        }}
                                    >
                                        {'\u20B9'}{product.price.toLocaleString('en-IN')}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px',
                            marginTop: '60px',
                        }}
                    >
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                            style={{
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#141414',
                                border: '1px solid #2A2A2A',
                                color: currentPage === 1 ? '#2A2A2A' : '#C9A96E',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                if (currentPage !== 1) e.currentTarget.style.borderColor = '#C9A96E';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#2A2A2A';
                            }}
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {[1, 2, 3].map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    fontWeight: currentPage === page ? 600 : 400,
                                    backgroundColor: currentPage === page ? '#C9A96E' : '#141414',
                                    color: currentPage === page ? '#0A0A0A' : '#C9A96E',
                                    border: currentPage === page ? '1px solid #C9A96E' : '1px solid #2A2A2A',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    if (currentPage !== page) {
                                        e.currentTarget.style.borderColor = '#C9A96E';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (currentPage !== page) {
                                        e.currentTarget.style.borderColor = '#2A2A2A';
                                    }
                                }}
                            >
                                {page}
                            </button>
                        ))}

                        <button
                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                            disabled={currentPage === totalPages}
                            style={{
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#141414',
                                border: '1px solid #2A2A2A',
                                color: currentPage === totalPages ? '#2A2A2A' : '#C9A96E',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                if (currentPage !== totalPages) e.currentTarget.style.borderColor = '#C9A96E';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#2A2A2A';
                            }}
                        >
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template21Shop;
